import { render } from "./share-planner.vue?vue&type=template&id=97fd8a4e&scoped=true&ts=true"
import script from "./share-planner.vue?vue&type=script&lang=ts"
export * from "./share-planner.vue?vue&type=script&lang=ts"

import "./share-planner.vue?vue&type=style&index=0&id=97fd8a4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fd8a4e"]])

export default __exports__